import { athleteCommandCenterData } from "../../../app/mock/athleteCommandCenterData";
import { Card } from "../../../components/ui/Card";
import { ConfidenceIndicator } from "../../../components/ui/ConfidenceIndicator";
import { SectionHeader } from "../../../components/ui/SectionHeader";
import { useAthleteProfile } from "../../athlete-profile/AthleteProfileProvider";
import { formatColdPlungeTiming, formatTemperatureFromFahrenheit } from "../../athlete-profile/formatters";

export function RecoveryPlan() {
  const recovery = athleteCommandCenterData.recovery;
  const { athleteProfile } = useAthleteProfile();
  const profileRecovery = athleteProfile.recovery;
  const preferredUnits = athleteProfile.personal.preferredUnits;
  const morningProtocolLabel = profileRecovery.morningColdPlungeEnabled ? "Cold plunge" : "Mobility";
  const morningProtocolDetail = profileRecovery.morningColdPlungeEnabled
    ? `${formatTemperatureFromFahrenheit(profileRecovery.morningColdPlungeTemperatureF, preferredUnits)} | ${profileRecovery.morningColdPlungeDurationMinutes} minutes | ${formatColdPlungeTiming(profileRecovery.morningColdPlungeTiming)}`
    : "Cold plunge disabled";
  const futureRecommendations = profileRecovery.contrastTherapyEnabled
    ? recovery.futureRecommendations
    : recovery.futureRecommendations.filter(item => item !== "Contrast Therapy");

  return (
    <Card>
      <SectionHeader
        eyebrow="RECOVERY PROTOCOL"
        title="Recovery sequence for today's load"
        subtitle="Morning and evening protocol with future recommendations"
      />
      <ConfidenceIndicator value={recovery.confidence} />
      <div className="recovery-grid">
        <article className="recovery-block">
          <h3>Morning Recovery Protocol</h3>
          <p>{morningProtocolLabel}</p>
          <small>{morningProtocolDetail}</small>
        </article>
        <article className="recovery-block">
          <h3>Evening Recovery Protocol</h3>
          <p>{recovery.eveningProtocol.modality}</p>
          <small>{recovery.eveningProtocol.recommendation}</small>
        </article>
        <article className="recovery-block">
          <h3>Sleep Target</h3>
          <p>{`${profileRecovery.preferredSleepHours} hours`}</p>
        </article>
        <article className="recovery-block">
          <h3>Mobility</h3>
          <p>{recovery.mobility}</p>
        </article>
        <article className="recovery-block">
          <h3>Future Recommendations</h3>
          <ul className="command-list compact-list">
            {futureRecommendations.map(item => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </article>
      </div>
    </Card>
  );
}
